import { render, staticRenderFns } from "./product_details.vue?vue&type=template&id=67968318&scoped=true&"
import script from "./product_details.vue?vue&type=script&lang=js&"
export * from "./product_details.vue?vue&type=script&lang=js&"
import style0 from "./product_details.vue?vue&type=style&index=0&id=67968318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67968318",
  null
  
)

export default component.exports